import type { MonthUsage } from '@hooks/subscription/use-month-usage';

/** Which page the strip sits on: Dok Pabean counts AJU, Dok Manifes House BL. */
export type CreditStripVariant = 'pabean' | 'manifest';

const DOC_ORDER = ['PIB', 'PEB'];

/**
 * The chips of the month's usage: PIB and PEB always (0 included), then any
 * other declaration type used this month; on Dok Manifes the House BLs.
 */
export function monthUsageChips(
  usage: MonthUsage | null,
  variant: CreditStripVariant
): { key: string; label: string; value: number }[] {
  if (variant === 'manifest') return [{ key: 'bl', label: 'House BL', value: usage?.houseBl ?? 0 }];
  const by = usage?.byDocLabel ?? {};
  const others = Object.keys(by)
    .filter((k) => !DOC_ORDER.includes(k) && by[k] > 0)
    .sort((a, b) => a.localeCompare(b));
  return [...DOC_ORDER, ...others].map((label) => ({ key: label, label, value: by[label] ?? 0 }));
}
